function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire37b7"];
parcelRequire.register("8nwgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61997f20c7869fe0$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $iqLBO = parcelRequire("iqLBO");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $koa2c = parcelRequire("koa2c");

var $6A0cm = parcelRequire("6A0cm");

var $8YrnH = parcelRequire("8YrnH");

var $lBrex = parcelRequire("lBrex");

var $9X0U9 = parcelRequire("9X0U9");
var $61997f20c7869fe0$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $61997f20c7869fe0$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $61997f20c7869fe0$var$focusRingStyles = (0, $lBrex.xcss)({
    ":focus-visible": $61997f20c7869fe0$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $61997f20c7869fe0$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $61997f20c7869fe0$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $6A0cm.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $61997f20c7869fe0$var$_excluded);
    var interactionContext = (0, $91i6m.useContext)((0, $8YrnH.default));
    var handleClick = (0, $91i6m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $koa2c.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "3.1.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $lBrex.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $61997f20c7869fe0$var$focusRingStyles
    ];
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $61997f20c7869fe0$export$2e2bcd8739ae039 = $61997f20c7869fe0$var$UNSAFE_PRESSABLE;

});

parcelRequire.register("fXpPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e067efc04f5090$export$2e2bcd8739ae039; });

var $iqLBO = parcelRequire("iqLBO");

var $91i6m = parcelRequire("91i6m");

var $9X0U9 = parcelRequire("9X0U9");
var $lBrex = parcelRequire("lBrex");
var $b9e067efc04f5090$var$textStyles = (0, $lBrex.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $b9e067efc04f5090$var$iconStyles = (0, $lBrex.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $b9e067efc04f5090$var$commonStyles = (0, $lBrex.xcss)({
    transition: "opacity 0.3s"
});
var $b9e067efc04f5090$var$fadeStyles = (0, $lBrex.xcss)({
    opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b9e067efc04f5090$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        as: "span",
        xcss: [
            $b9e067efc04f5090$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(type === "text" ? [
            $b9e067efc04f5090$var$textStyles
        ] : [
            $b9e067efc04f5090$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(hasOverlay ? [
            $b9e067efc04f5090$var$fadeStyles
        ] : []))
    }, children);
};
var $b9e067efc04f5090$export$2e2bcd8739ae039 = $b9e067efc04f5090$var$Content;

});

parcelRequire.register("6U7Fi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $506deb25fd0d8934$export$2e2bcd8739ae039; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $a4cH2 = parcelRequire("a4cH2");

var $9X0U9 = parcelRequire("9X0U9");
var $lBrex = parcelRequire("lBrex");

var $ImPgp = parcelRequire("ImPgp");

var $7ZUmN = parcelRequire("7ZUmN");

var $azhMS = parcelRequire("azhMS");
function $506deb25fd0d8934$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $506deb25fd0d8934$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $506deb25fd0d8934$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $506deb25fd0d8934$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $506deb25fd0d8934$var$overlayStyles = (0, $lBrex.xcss)({
    position: "absolute",
    insetInlineStart: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetBlockEnd: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $506deb25fd0d8934$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing;
    var ourRef = (0, $91i6m.useRef)();
    var splitButtonContext = (0, $ImPgp.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isHighlighted = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isHighlighted) || false;
    var isActiveOverSelected = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isActiveOverSelected) || false;
    var setRef = (0, $91i6m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref === null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    (0, $a4cH2.default)(ourRef, autoFocus);
    var buttonXCSS = (0, $91i6m.useMemo)(function() {
        return (0, $azhMS.getXCSS)({
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isHighlighted: isHighlighted,
            isActiveOverSelected: isActiveOverSelected,
            shouldFitContainer: shouldFitContainer,
            isIconButton: isIconButton,
            isCircle: isCircle,
            hasOverlay: Boolean(overlay),
            isLink: buttonType === "link",
            hasIconBefore: hasIconBefore,
            hasIconAfter: hasIconAfter,
            isSplit: isSplitButton,
            isNavigationSplit: isNavigationSplitButton
        });
    }, [
        appearance,
        buttonType,
        spacing,
        isDisabled,
        isSelected,
        isHighlighted,
        isActiveOverSelected,
        isIconButton,
        isCircle,
        shouldFitContainer,
        overlay,
        hasIconBefore,
        hasIconAfter,
        isSplitButton,
        isNavigationSplitButton
    ]);
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    return $506deb25fd0d8934$var$_objectSpread({
        ref: setRef,
        xcss: buttonXCSS,
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
            as: "span",
            xcss: $506deb25fd0d8934$var$overlayStyles
        }, overlay) : null)
    }, (0, $7ZUmN.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $506deb25fd0d8934$export$2e2bcd8739ae039 = $506deb25fd0d8934$var$useButtonBase;

});
parcelRequire.register("ImPgp", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $0855d0e91824b675$export$47e2c6fdb142d947; });

var $91i6m = parcelRequire("91i6m");
var $0855d0e91824b675$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $91i6m.createContext)(undefined);
var $0855d0e91824b675$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $91i6m.useContext)($0855d0e91824b675$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRequire.register("7ZUmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d29f42e5bfd9987$export$2e2bcd8739ae039; });
function $5d29f42e5bfd9987$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5d29f42e5bfd9987$var$tabKeyCode = 9;
function $5d29f42e5bfd9987$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5d29f42e5bfd9987$var$tabKeyCode) return;
    $5d29f42e5bfd9987$var$abort(event);
}
function $5d29f42e5bfd9987$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5d29f42e5bfd9987$var$abort,
        onMouseUpCapture: $5d29f42e5bfd9987$var$abort,
        onKeyDownCapture: $5d29f42e5bfd9987$var$onKey,
        onKeyUpCapture: $5d29f42e5bfd9987$var$onKey,
        onTouchStartCapture: $5d29f42e5bfd9987$var$abort,
        onTouchEndCapture: $5d29f42e5bfd9987$var$abort,
        onPointerDownCapture: $5d29f42e5bfd9987$var$abort,
        onPointerUpCapture: $5d29f42e5bfd9987$var$abort,
        onClickCapture: $5d29f42e5bfd9987$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5d29f42e5bfd9987$var$abort
    } : events;
}

});

parcelRequire.register("azhMS", function(module, exports) {

$parcel$export(module.exports, "getXCSS", function () { return $7b1af87bf8ecf509$export$f9dc8dc4cff30fc6; });

var $dsN6L = parcelRequire("dsN6L");

var $lBrex = parcelRequire("lBrex");

var $6e88g = parcelRequire("6e88g");

var $9PJhp = parcelRequire("9PJhp");
function $7b1af87bf8ecf509$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b1af87bf8ecf509$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b1af87bf8ecf509$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b1af87bf8ecf509$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b1af87bf8ecf509$var$fontSize = (0, $6e88g.fontSize)();
var $7b1af87bf8ecf509$export$6c2552e9776539bb = {
    default: "".concat(32 / $7b1af87bf8ecf509$var$fontSize, "em"),
    compact: "".concat(24 / $7b1af87bf8ecf509$var$fontSize, "em"),
    none: "auto"
};
var $7b1af87bf8ecf509$var$lineHeights = {
    default: $7b1af87bf8ecf509$export$6c2552e9776539bb.default,
    compact: $7b1af87bf8ecf509$export$6c2552e9776539bb.compact,
    none: "inherit"
};
var $7b1af87bf8ecf509$var$paddingInline = {
    default: {
        default: "space.150",
        withIcon: "space.100"
    },
    compact: {
        default: "space.150",
        withIcon: "space.100"
    },
    none: {
        default: "space.0",
        withIcon: "space.0"
    }
};
var $7b1af87bf8ecf509$var$gap = {
    compact: "space.050",
    default: "space.050",
    none: "space.0"
};
var $7b1af87bf8ecf509$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $7b1af87bf8ecf509$var$splitBorderStyles = {
    ":focus-visible": {
        zIndex: 1
    }
};
function $7b1af87bf8ecf509$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key;
    return group[key] || group.default;
}
function $7b1af87bf8ecf509$var$getColors(_ref2) {
    var appearance = _ref2.appearance, _ref2$interactionStat = _ref2.interactionState, interactionState = _ref2$interactionStat === void 0 ? "default" : _ref2$interactionStat, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, isHighlighted = _ref2.isHighlighted, isActiveOverSelected = _ref2.isActiveOverSelected, hasOverlay = _ref2.hasOverlay;
    var key = interactionState;
    // Overlay does not change color on interaction, revert to 'default' or resting state
    key = hasOverlay ? "default" : key;
    key = isSelected || isHighlighted ? isActiveOverSelected ? "active" : "selected" : key;
    // Disabled colors overrule everything else
    key = isDisabled ? "disabled" : key;
    return {
        backgroundColor: $7b1af87bf8ecf509$var$getColor({
            group: (0, $9PJhp.default).background[appearance],
            key: key
        }),
        color: "".concat($7b1af87bf8ecf509$var$getColor({
            group: (0, $9PJhp.default).color[appearance],
            key: key
        }))
    };
}
function $7b1af87bf8ecf509$export$f9dc8dc4cff30fc6(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, isHighlighted = _ref3.isHighlighted, isActiveOverSelected = _ref3.isActiveOverSelected, isIconButton = _ref3.isIconButton, isCircle = _ref3.isCircle, shouldFitContainer = _ref3.shouldFitContainer, isLink = _ref3.isLink, isSplit = _ref3.isSplit, isNavigationSplit = _ref3.isNavigationSplit, hasOverlay = _ref3.hasOverlay, hasIconBefore = _ref3.hasIconBefore, hasIconAfter = _ref3.hasIconAfter;
    var baseColors = $7b1af87bf8ecf509$var$getColors({
        appearance: appearance,
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        isActiveOverSelected: isActiveOverSelected,
        isDisabled: isDisabled
    });
    var combinedBaseColorStyles = isLink ? $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, baseColors), {}, {
        textDecoration: "none",
        // Disabling visited styles (by re-declaring the base colors)
        ":visited": baseColors
    }) : isNavigationSplit && !isSelected ? $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, baseColors), {}, {
        backgroundColor: "color.background.neutral.subtle"
    }) : baseColors;
    var height = $7b1af87bf8ecf509$export$6c2552e9776539bb[spacing];
    var width = shouldFitContainer ? "100%" : "auto";
    width = isIconButton ? isNavigationSplit ? "24px" : height : width;
    var defaultPaddingInlineStart = $7b1af87bf8ecf509$var$paddingInline[spacing][hasIconBefore ? "withIcon" : "default"];
    var defaultPaddingInlineEnd = $7b1af87bf8ecf509$var$paddingInline[spacing][hasIconAfter ? "withIcon" : "default"];
    var splitButtonStyles = isSplit ? $7b1af87bf8ecf509$var$splitBorderStyles : {};
    var getNavigationSplitButtonPaddings = function getNavigationSplitButtonPaddings() {
        if (isNavigationSplit) return {
            paddingInlineStart: "space.075",
            paddingInlineEnd: "space.075"
        };
        return {
            paddingInlineStart: isIconButton ? "space.0" : defaultPaddingInlineStart,
            paddingInlineEnd: isIconButton ? "space.0" : defaultPaddingInlineEnd
        };
    };
    var _getNavigationSplitBu = getNavigationSplitButtonPaddings(), paddingInlineStart = _getNavigationSplitBu.paddingInlineStart, paddingInlineEnd = _getNavigationSplitBu.paddingInlineEnd;
    return (0, $lBrex.xcss)($7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({
        alignItems: "baseline",
        borderWidth: "border.width.0",
        borderRadius: isCircle && !isSplit ? "border.radius.circle" : "border.radius.100",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        fontFamily: "inherit",
        fontWeight: 500,
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap",
        height: height,
        lineHeight: $7b1af87bf8ecf509$var$lineHeights[spacing],
        paddingBlock: "space.0",
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        columnGap: $7b1af87bf8ecf509$var$gap[spacing],
        verticalAlign: $7b1af87bf8ecf509$var$verticalAlign[spacing],
        width: width,
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, combinedBaseColorStyles), isDisabled || hasOverlay ? {
        cursor: "not-allowed"
    } : {}), {}, {
        ":hover": $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, $7b1af87bf8ecf509$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "hover",
            hasOverlay: hasOverlay
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "none",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        ":active": $7b1af87bf8ecf509$var$_objectSpread($7b1af87bf8ecf509$var$_objectSpread({}, $7b1af87bf8ecf509$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "active",
            hasOverlay: hasOverlay
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        })
    }, splitButtonStyles));
}

});
parcelRequire.register("9PJhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $728c0014d32d53d9$export$2e2bcd8739ae039; });

var $kLNLK = parcelRequire("kLNLK");
var $728c0014d32d53d9$var$values = {
    // Default appearance
    background: {
        default: {
            /**
       * Some colors need specific fallback colors specified
       * to match the original Button when no theme is active.
       *
       * This is because the `xcss` automatic token fallbacks use
       * the legacy themes, which do not match original colors.
       */ // @ts-expect-error
            default: "var(--ds-background-neutral, ".concat($kLNLK.N20A, ")"),
            hover: "color.background.neutral.hovered",
            active: "color.background.neutral.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        primary: {
            default: "color.background.brand.bold",
            hover: "color.background.brand.bold.hovered",
            active: "color.background.brand.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        warning: {
            default: "color.background.warning.bold",
            hover: "color.background.warning.bold.hovered",
            active: "color.background.warning.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.Y400, ")")
        },
        danger: {
            default: "color.background.danger.bold",
            hover: "color.background.danger.bold.hovered",
            active: "color.background.danger.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($kLNLK.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.R500, ")")
        },
        link: {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        subtle: {
            default: "color.background.neutral.subtle",
            hover: "color.background.neutral.subtle.hovered",
            active: "color.background.neutral.subtle.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-neutral-subtle, none)",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        },
        "subtle-link": {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($kLNLK.N700, ")")
        }
    },
    color: {
        default: {
            // @ts-expect-error
            default: "var(--ds-text, ".concat($kLNLK.N500, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.B400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        primary: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        warning: {
            default: "color.text.warning.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N800, ")")
        },
        danger: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N0, ")")
        },
        link: {
            default: "color.link",
            // @ts-expect-error
            hover: "var(--ds-link, ".concat($kLNLK.B300, ")"),
            active: "color.link.pressed",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        subtle: {
            // @ts-expect-error
            default: "var(--ds-text, ".concat($kLNLK.N500, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.B400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        },
        "subtle-link": {
            // @ts-expect-error
            default: "var(--ds-text-subtle, ".concat($kLNLK.N200, ")"),
            // @ts-expect-error
            hover: "var(--ds-text-subtle, ".concat($kLNLK.N90, ")"),
            // @ts-expect-error
            active: "var(--ds-text, ".concat($kLNLK.N400, ")"),
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($kLNLK.N20, ")")
        }
    }
};
var $728c0014d32d53d9$export$2e2bcd8739ae039 = $728c0014d32d53d9$var$values;

});




//# sourceMappingURL=MultiFactorPage.53e1b1f9.js.map
